import { init, RematchRootState, RematchDispatch, Models } from '@rematch/core';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { global } from 'app/store/global.slice';
import { timer } from 'entities/Timer/Timer.slice';
import { physicianList } from 'entities/Physician/Physician.slice';
import { patientMetrics } from 'entities/PatientMetrics/PatientMetrics.slice';
import { auth } from 'entities/Auth/Auth.slice';
import { statistics } from 'entities/Statistics/Statistics.slice';
import { eventList, event } from 'entities/Events/Event.slice';
import { patient } from 'entities/Patient/Patient.slice';
import { note, noteList } from 'entities/Notes/Note.slice';
import { historyList } from 'entities/History/History.slice';
import { twilio } from 'entities/Calls/Twilio.slice';
import { modal } from 'entities/Modal/Modal.slice';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const reducers = { router: routerReducer };

export interface IRootModel extends Models<IRootModel> {
  modal: typeof modal;
  global: typeof global;
  auth: typeof auth;
  eventList: typeof eventList;
  event: typeof event;
  patient: typeof patient;
  timer: typeof timer;
  noteList: typeof noteList;
  note: typeof note;
  historyList: typeof historyList;
  statistics: typeof statistics;
  physicianList: typeof physicianList;
  twilio: typeof twilio;
  patientMetrics: typeof patientMetrics;
}

const models = {
  modal,
  global,
  auth,
  eventList,
  event,
  patient,
  timer,
  noteList,
  note,
  historyList,
  statistics,
  physicianList,
  twilio,
  patientMetrics,
} as IRootModel;

const store = init<IRootModel>({
  redux: {
    reducers,
    middlewares: [routerMiddleware],
  },
  models,
});

export default store;
export const history = createReduxHistory(store);
export type AppState = RematchRootState<IRootModel>;
export type AppDispatch = RematchDispatch<IRootModel>;
